import { z } from 'zod';
/** Admin "save job" payload. Mirrors Admin\JobsController::save(). */
export const jobSaveSchema = z
    .object({
    title: z.string().min(1).max(255),
    status: z.enum(['published', 'stopped']),
    /** Old form field `description` -> stored as `content`. */
    content: z.string().min(1),
    workFromHome: z.boolean().default(false),
    salary: z.number().int().positive().nullable().default(null),
    currency: z.enum(['BGN', 'EUR', 'USD']).nullable().default(null),
})
    .refine((v) => v.salary === null || v.currency !== null, {
    message: 'Currency is required when a salary is set',
    path: ['currency'],
});
//# sourceMappingURL=job.js.map